import type { DateRange } from './DateRange';
import { createMonthDateRange, createWeekDateRange } from './DateRange';
import type { OwaDate } from 'owa-datetime';
import { startOfWeek, addDays, isWithinRange } from 'owa-datetime';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import type { DayOfWeek } from '@fluentui/date-time-utilities';
import { DateRangeType } from '@fluentui/date-time-utilities';

/**
 * Calculate the date range of items that should be requested from the service
 */
export default function calculateRequestRange(
    selectedDate: OwaDate,
    dateRange: DateRange,
    dateRangeType: DateRangeType,
    weekStartDay: DayOfWeek
): DateRange {
    let requestRange: DateRange;

    let date = selectedDate;
    if (!isWithinRange(date, dateRange.start, dateRange.end)) {
        date = dateRange.start;
    }

    if (dateRangeType == DateRangeType.Month) {
        requestRange = createMonthDateRange(date, weekStartDay);
    } else {
        // Work Week requests the full week, like Week, so switching views or navigating
        // between adjacent weeks reuses the cached range instead of evicting it.
        const rangeToRequest =
            dateRangeType == DateRangeType.WorkWeek &&
            isGlobalFeatureEnabled('cal-workweek-full-week-request')
                ? createWeekDateRange(weekStartDay, date)
                : dateRange;

        requestRange = {
            start: startOfWeek(date, weekStartDay),
            end: addDays(rangeToRequest.end, 1),
        };
    }
    return requestRange;
}
